import ReactDOM from 'react-dom';

import reportWebVitals from './reportWebVitals';

import { Route, Routes } from 'react-router';

import { BrowserRouter } from "react-router-dom";

import AuthProvider from '@auth/AuthProvider'
import RequireAuth from '@auth/RequireAuth'

import ChurchDataProvider from '@data/ChurchDataProvider'

import TeamManager from '@pages/TeamManager'
import MinistryDataPage from '@pages/MinistryData'

import Playlists from '@pages/v2/Playlists';
import Welcome from '@pages/v2/Welcome';

import Connections from '@pages/Connections';
import Events from '@pages/Events';
import CreateEvent from '@pages/Events/CreateEvent';
import CreateEventDetails from '@pages/Events/CreateEvent/Details';
import CreateEventExternal from '@pages/Events/CreateEvent/Import';

import LoginPage from '@pages/LoginPage';

import './index.scss';
import '@styles/modal.scss'

import Modal from 'react-modal'
import ResetPasswordPage from '@pages/ResetPasswordPage';

// MARK: - V2

import Appv2 from './Appv2'
import ConnectionsRedirectPage from '@pages/Connections/Redirect';
import EventDetailsPage from '@pages/Events/DetailsPage';

Modal.setAppElement('#root');

ReactDOM.render(
  <>
    <BrowserRouter>
      <AuthProvider>
        <ChurchDataProvider>
          <Routes>
            <Route element={<RequireAuth />}>
              <Route path="/" element={<Appv2 />}>
                <Route index element={<Welcome />} />
                <Route path="home" element={<Welcome />} />
                <Route path="service-plans" element={<MinistryDataPage />} />
                <Route path="playlists" element={<Playlists />} />
                <Route path="team" element={<TeamManager />} />

                <Route path="connections/redirect" element={<ConnectionsRedirectPage />} />
                <Route path="connections" element={<Connections />} />

                <Route path="events" element={<Events />} />
                <Route path="events/create" element={<CreateEvent />} />
                <Route path="events/create/details" element={<CreateEventDetails />} />
                <Route path="events/create/import" element={<CreateEventExternal />} />
                <Route path="events/:eventID" element={<EventDetailsPage />} />

                <Route
                  path="*"
                  element={
                    <main style={{ padding: "1rem" }}>
                      <p>There's nothing here!</p>
                    </main>
                  }
                />
              </Route>
            </Route>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
          </Routes>
        </ChurchDataProvider>
      </AuthProvider>
    </BrowserRouter>
  </>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
